var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11V19.5C19 20.0523 18.5523 20.5 18 20.5H6C5.44772 20.5 5 20.0523 5 19.5V5.5C5 4.94772 5.44772 4.5 6 4.5H12.5V8.5C12.5 9.88071 13.6193 11 15 11H19ZM18.616 10L13.6494 4.8087C13.6036 4.76082 13.5535 4.71799 13.5 4.68058V8.5C13.5 9.32843 14.1716 10 15 10H18.616ZM4 5.5C4 4.39543 4.89543 3.5 6 3.5H12.9268C13.4726 3.5 13.9946 3.72304 14.3719 4.1174L19.4451 9.42004C19.8012 9.79225 20 10.2875 20 10.8026V19.5C20 20.6046 19.1046 21.5 18 21.5H6C4.89543 21.5 4 20.6046 4 19.5V5.5Z",
    fill: "#3483FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReport);
export default __webpack_public_path__ + "static/media/ico-report.9510a4e7137fe23c2c53b238ba5a4320.svg";
export { ForwardRef as ReactComponent };